import { render } from "./ShipService2.vue?vue&type=template&id=7a8f4f8b&scoped=true"
import script from "./ShipService2.vue?vue&type=script&lang=js"
export * from "./ShipService2.vue?vue&type=script&lang=js"

import "./ShipService2.vue?vue&type=style&index=0&id=7a8f4f8b&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../Users/karimdmai2026/Eurekali-Souverainete/eurekali-b2c/eurekalifront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a8f4f8b"]])

export default __exports__